// Layout chrome for the platform-admin panel (ADR-0024).
//
// Sibling of the regular Shell, NOT a child — the regular Shell mounts
// useFacilityDashboard() which is org-scoped and meaningless for a
// platform admin operating across all orgs. AdminShell renders the
// same chrome shape (sidebar + main outlet) using the existing CSS
// classes so the visual treatment stays consistent.

import { Outlet } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";

export function AdminShell() {
  return (
    <div className="app">
      <div className="app__sidebar">
        <AdminSidebar />
      </div>
      <main className="app__main">
        <Outlet />
      </main>
    </div>
  );
}
